import Twemoji from "react-twemoji";
import { useUser } from "context/userContext";

const Message = ({ text }) => (
  <Twemoji tag="span" options={{ className: "twemoji" }}>
    <span dangerouslySetInnerHTML={{ __html: text }} />
  </Twemoji>
);

export const messages = {
  welcome: {
    fun: "Welcome back, [User]! 👋",
    plain: "Welcome back, [User]!",
  },
  notifications: {
    feed: {
      fun: "[Message] 🎉",
      plain: "[Message]",
    },
    orderSuccess: {
      fun: "Order placed successfully ✅🎉",
      plain: "Order placed successfully",
    },
    toastSuccess: {
      fun: "[Message] ✅🎉",
      plain: "[Message]",
    },
  },
  emptyTable: {
    fun: "No [TableName] yet 📭 — Let's get things moving!",
    plain: "No [TableName] yet — Let's get things moving!",
  },
  errorMessage: {
    fun: "Something went wrong ⚠️ Please try again.",
    plain: "Something went wrong. Please try again.",
  },
  dashboard: {
    lowInventoryProducts: {
      fun: "Low Inventory Products ⚠️📦",
      plain: "Low Inventory Products",
    },
    topCustomerName: {
      fun: "[Name] 🏆",
      plain: "[Name]",
    },
    topCustomer: {
      fun: "Top Customer 🛒",
      plain: "Top Customer",
    },
    noOfCustomers: {
      fun: "No of Customers 🛒",
      plain: "No of Customers",
    },
    monthlyOrders: {
      fun: "Total Monthly Orders 📅",
      plain: "Total Monthly Orders",
    },
    monthlySales: {
      fun: "Total Monthly Sales 📅",
      plain: "Total Monthly Sales",
    },
    weeklyOrders: {
      fun: "Total Weekly Orders 📅",
      plain: "Total Weekly Orders",
    },
    weeklySales: {
      fun: "Total Weekly Sales 📅",
      plain: "Total Weekly Sales",
    },
    topSalesRep: {
      fun: "Top Sales Rep 🏆",
      plain: "Top Sales Rep",
    },
    noOfSalesRep: {
      fun: "No. of Sales Reps 🧑‍💼",
      plain: "No. of Sales Reps",
    },
    sales: {
      fun: "Sales 💰",
      plain: "Sales",
    },
    backOrders: {
      fun: "Back Orders 📦⏳",
      plain: "Back Orders",
    },
    shortFillRate: {
      fun: "Short Fill Rate ⚠️",
      plain: "Short Fill Rate",
    },
    fallOff: {
      fun: "Fall Off 📉",
      plain: "Fall Off",
    },
    activeBuyers: {
      fun: "Active Customers 🧍‍♂️🧍‍♀️",
      plain: "Active Customers",
    },
    topTerritory: {
      fun: "Top Territory 🗺️",
      plain: "Top Territory",
    },
    description: {
      fun: "[Message]",
      plain: "[Message]",
    },
  },
  settings: {
    notifications: {
      fun: "Notifications 🔔",
      plain: "Notifications",
    },
    integrations: {
      fun: "Link Integrations 🔗",
      plain: "Link Integrations",
    },
  },
  products: {
    fun: "Products 📦",
    plain: "Products",
  },
};

export const useFunText = () => {
  const { getAccount } = useUser();
  const account = getAccount();

  const getFunText = (keyPath, replacements = {}) => {
    const keys = keyPath.split(".");
    let current = messages;

    for (const key of keys) {
      if (!current[key]) return "";
      current = current[key];
    }

    const is86Fun = account?.is86Fun ?? false;

    let text = is86Fun ? current.fun : current.plain;
    Object.entries(replacements).forEach(([key, value]) => {
      text = text.replace(`[${key}]`, value);
    });

    return is86Fun ? <Message text={text} /> : text;
  };

  return { getFunText };
};
